import { Suspense } from 'react';
import { Box, MantineColor, MantineSpacing, ScrollArea } from '@mantine/core';
import { AppBreadcrumbs } from './AppBreadcrumbs';
import { ContentPaneOverlayProvider, ContentPaneOverlaySlot } from './ContentPaneOverlay';
import PageLoader from 'src/UI/loader/PageLoader';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  bg?: MantineColor;
  p?: MantineSpacing;
  collapsed?: boolean;
};

export function AppContentPane({ children, style, bg, p, collapsed }: Props) {
  return (
    <ContentPaneOverlayProvider>
      <Box
        pos="relative"
        bg={bg ?? 'contentBackground'}
        style={{
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          overflow: 'hidden',
          flexGrow: collapsed ? 0 : 1,
          flexShrink: 0,
          flexBasis: 0,
          opacity: collapsed ? 0 : 1,
          minWidth: 0,
          transition: 'flex-grow 0.35s ease, opacity 0.25s ease',
          ...style,
        }}
      >
        <ContentPaneOverlaySlot />
        <ScrollArea
          h="100%"
          w="100%"
          scrollbarSize={6}
          type="scroll"
          styles={{
            root: {
              borderRadius:
                'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
            },
            content: {
              minHeight: '100%',
              height: '100%',
            },
            viewport: {
              overscrollBehavior: 'contain',
            },
            scrollbar: {
              background: 'transparent',
              marginTop: 'var(--mantine-spacing-xxl)',
              marginBottom: 'var(--mantine-spacing-xxxl)',
              marginRight: 2,
              padding: 0,
            },
            thumb: {
              background: 'black',
            },
          }}
        >
          <Box bg={bg ?? 'contentBackground'} px={p ?? 'xxl'} py={p ?? 'lg'} h="100%">
            <AppBreadcrumbs />
            <Suspense fallback={<PageLoader absolute={false} />}>{children}</Suspense>
          </Box>
        </ScrollArea>
      </Box>
    </ContentPaneOverlayProvider>
  );
}
